var _linearGradient, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVpsHosting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 45,
    viewBox: "0 0 44 45",
    width: 44,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 13.4249,
    x2: 45.7809,
    y1: 36.0714,
    y2: 13.3212
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4312a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25638,
    stopColor: "#6233df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#849bff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.2584 10c-.2977.0007-.5922.06-.8668.1747-.2747.1146-.524.2823-.7338.4934-.2097.2111-.3758.4616-.4887.7369-.1128.2754-.1703.5703-.1691.8679v20.4542c-.0012.2976.0563.5925.1691.8679.1129.2753.279.5258.4887.7369.2098.2111.4591.3788.7338.4934.2746.1147.5691.174.8668.1747h12.15c.2976-.0007.5921-.06.8667-.1747.2747-.1146.524-.2823.7338-.4934.2097-.2111.3758-.4616.4887-.7369.1129-.2754.1703-.5703.1691-.8679v-20.4542c.0012-.2976-.0562-.5925-.1691-.8679-.1129-.2753-.279-.5258-.4887-.7369-.2098-.2111-.4591-.3788-.7338-.4934-.2746-.1147-.5691-.174-.8667-.1747zm0 2.2729h12.15v11.3625h-12.15zm2.6822 2.2729v2.2719h6.7855v-2.2719zm0 4.5448v2.2729h6.7855v-2.2729zm3.3928 8.5229c.9364 0 1.6958.7636 1.6958 1.7042s-.7594 1.7052-1.6958 1.7052c-.451-.0014-.883-.1818-1.201-.5015-.318-.3198-.496-.7527-.4949-1.2037 0-.9406.7594-1.7042 1.6959-1.7042z",
    fill: "url(#a)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVpsHosting);
export default __webpack_public_path__ + "static/media/vps-hosting.433c50361fe520ba53ca1af0395bbace.svg";
export { ForwardRef as ReactComponent };